import React from 'react'
import '../../index.css'
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import angeldestroying from '../../Assets/Img/angeldestroying.png'

const Chap12 = () => {
  return (
    <div className="chapter-container">
      
      <div className="chapterFooter">
          <Link to="/Chap11">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap13">Next</Link>
      </div>

      <h1 className='chapterHeading'>Chapter 12: Plagues of the Seven Angels</h1>

      <img src={angeldestroying} className='image' alt='Angel appearing over a city' />

    <div className="wrapper">


    <div className='paragraph'>
          <p>Joseph Smith taught that once the 144,000’s work of gathering the righteous to Zion is complete, the seven angels 
            mentioned in the Book of Revelation will release plagues and pestilence in a final cleansing, resulting in the death of 
            those sinful souls who fight against Christ and his Zion, refusing to repent. To the early Mormons, these were not 
            metaphorical devices, but literal events on the near horizon. Seven angels would appear on the earth from heaven and 
            carry out this work. Joseph described the souls that are to be destroyed. “Satan has great hold upon their hearts … 
            their hearts are corrupt, and full of wickedness and abominations; and they love darkness rather than light.”
            <btn id="clickable1" className="footnote">1 </btn>
            <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>D&C 10:20-21.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Through the plagues and pestilence released by the angels, all that is corruptible must be consumed. Joseph revealed, 
            “And every corruptible thing, both of man, or of the beasts of the field, or of the fowls of the heavens, or of the 
            fish of the sea, that dwells upon all the face of the earth, shall be consumed.”
            <btn id="clickable2" className="footnote">2 </btn>
            <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>D&C 101:23-24.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>The cleansing must come, so that the earth and its inhabitants may be sanctified. Then a paradisiacal world of light and 
            beauty can be forged. The earth will return to its terrestrial state before the fall – a blissful Eden. 
            The celestialization of the Earth will occur after the 1,000-year Millennium when the earth is brought back into 
            the presence of God and the rays of God’s world further sanctify our earth. Joseph taught, “This earth will be rolled back 
            into the presence of God and crowned with celestial glory.”
            <btn id="clickable3" className="footnote">3 </btn>
            <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Quoted by William Clayton, reporting an undated discourse given by Joseph Smith in Nauvoo, Illinois; in L. John Nuttall, “Extracts from William Clayton’s Private Book,” p. 8, Journals of L. John Nuttall, 1857–1904, Special Collections, BYU; copy in Church Archives.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>But first, at the Second Coming from the brilliance of Christ’s glory, the earth will be purified to a terrestrial state and Michael, the archangel will crown Christ as ruler of the earth and give him all dominion, kingdoms, glory, power, and majesty.
          </p>
        </div>

        <h2 className="headlinePadding">John Sees the Judgments and Destruction of the Seven Angels</h2>

        <div className='paragraph'>
          <p>In the Book of Revelation, John sees the seventh seal opened – the last seven-thousand-year period. He sees seven angels 
            standing before God holding trumps. Joseph Smith revealed, “… in the beginning of the seventh thousand years will the Lord 
            God sanctify the earth, and complete the salvation of man ... The sounding of the trumpets of the seven angels are the 
            preparing and finishing of his work.”
            <btn id="clickable4" className="footnote">4 </btn>
            <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>D&C 77:12.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>At different intervals, the seven angels will each sound a trump, unleashing some form of destruction upon the world. 
            John reports, “The first angel sounded, and there followed hail and fire mingled with blood, and they were cast upon 
            the earth: and the third part of trees was burnt up, and all green grass was burnt up.”
            <btn id="clickable5" className="footnote">5 </btn>
            <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>Revelation 8:7.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>Then the second angel “sounded, and as it were a great mountain burning with fire was cast into the sea: and the 
            third part of the sea became blood. And the third part of the creatures which were in the sea, and had life, died; 
            and the third part of the ships were destroyed.”  
            <btn id="clickable6" className="footnote">6 </btn>
            <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>Revelation 8:8-9.</Tooltip>
            
            John sees stars falling from heaven, “And the third angel sounded, and there fell a great star from heaven, burning as it 
            were a lamp, and it fell upon the third part of the rivers, and upon the fountains of waters; And the name of the star is 
            called Wormwood: and the third part of the waters became wormwood; and many men died of the waters, because they were made 
            bitter.”
            <btn id="clickable7" className="footnote">7 </btn>
            <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Revelation 8:10-11.</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>When the fourth angel sounded “the third part of the sun was smitten, and the third part of the moon, and the third part 
            of the stars; so, as the third part of them was darkened, and the day shone not for a third part of it, and the night 
            likewise.”  
            <btn id="clickable8" className="footnote">8 </btn>
            <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Revelation 8:12.</Tooltip>
            
            Then John reports seeing “an angel flying through the midst of heaven, saying with a loud voice, Woe, woe, 
            woe, to the inhabiters of the earth by reason of the other voices of the trumpet of the three angels, which 
            are yet to sound!” This angel is not one of the seven destroying angels. He is making an announcement.
          </p>
        </div>

        <div className='paragraph'>
          <p>The next three trumps announce even greater destruction to cleanse the earth, and they will not be stayed until Christ 
            comes in glory.  
            <btn id="clickable9" className="footnote">9 </btn>
            <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>D&C 97:22-24; 112:23-24.</Tooltip>
            
            Then John states “… the fifth angel sounded, and I saw a star fall from heaven unto the earth: and to him was given the 
            key of the bottomless pit.” The fifth angel opens the bottomless pit. Smoke emerges, and the sun and air are darkened. 
            Out of the smoke locust “liken unto horses prepared unto battle” with the power of scorpions filled the air.  
            <btn id="clickable10" className="footnote">10 </btn>
            <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>Revelation 9:1-3.</Tooltip>
            
            The sixth angel sounds his trump and John “heard a voice from the four horns of the golden altar, which is before God, 
            Saying to the sixth angel … Loose the four angels which are bound in the great river Euphrates.”
            <btn id="clickable11" className="footnote">11 </btn>
            <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>Revelation 9:13-14</Tooltip>
          </p>
        </div>

        <div className='paragraph'>
          <p>John watches as the four angels are loosed, “which were prepared for an hour, and a day, and a month, and a year, 
            for to slay the third part of men.”  
            <btn id="clickable12" className="footnote">12 </btn>
            <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Revelation 9:15.</Tooltip>
            
            John sees “… the horses in the vision, and them that sat on them, having breastplates of fire, and of jacinth, 
            and brimstone: and the heads of the horses were as the heads of lions; and out of their mouths issued fire and smoke and 
            brimstone.”  
            <btn id="clickable13" className="footnote">13 </btn>
            <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Revelation 9:17.</Tooltip>
            
            These creatures kill one-third of the men on the earth. Then John reports that the men not killed by these plagues 
            repented not of their works, including the “worship [of] devils, and idols of gold … Neither repented they of their 
            murders, nor of their sorceries, nor of their fornication, nor of their thefts.” 
            <btn id="clickable14" className="footnote">14 </btn>
            <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Revelation 9:20-21.</Tooltip>
          </p>
        </div>

        <h2 className="headlinePadding">Work of the Seventh Angel: Michael/Adam</h2>

        <div className='paragraph'>
          <p>Joseph Smith identified the seventh angel, the archangel, in John’s vision as Michael/Adam. In contrast to the first six 
            angels, Michael's mission is to complete the work so that Christ may receive a glorious inheritance.
            <btn id="clickable15" className="footnote">15 </btn>
            <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>D&C 77:12.</Tooltip> 
          </p>
        </div>

        <div className='paragraph'>
          <p>John reports, “And I saw another mighty angel come down from heaven, clothed with a cloud: and a rainbow was upon his 
            head, and his face was as it were the sun, and his feet as pillars of fire.”  
            <btn id="clickable16" className="footnote">16 </btn>
            <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Revelation 10:1.</Tooltip> 
            
            John sees the angel stand on the sea and earth and declare, “There should be time no longer.”  
            <btn id="clickable17" className="footnote">17 </btn>
            <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Revelation 10:6.</Tooltip> 
            
            John writes that “in the days of the voice of the seventh angel ... the mystery of God should be finished.”  
            <btn id="clickable18" className="footnote">18 </btn>
            <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Revelation 10:7.</Tooltip> 
            
            John also hears “a great voice out of the temple of heaven, from the throne, saying, It is done.”  
            <btn id="clickable19" className="footnote">19 </btn>
            <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Revelation 16:17.</Tooltip> 
            
            Christ will then have overcome and trodden the winepress alone, even the winepress of the fierceness of the wrath of 
            Almighty God. At this time, Satan will be bound and will not be loosed for the space of a thousand years.
            <btn id="clickable20" className="footnote">20 </btn>
            <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>Revelation 20.</Tooltip>  
          </p>
        </div>

        <div className='paragraph'>
          <p>John hears great voices in heaven, saying, “The kingdoms of this world are become the kingdoms of our Lord and of his Christ; and he shall reign for ever and ever.” At this, the 24 elders, who sat before God on their seats, fell upon their faces and worshiped God. John hears them saying, “We give thee thanks, O Lord God Almighty, which art, and wast, and art to come; because thou hast taken to thee thy great power, and hast reigned.”
          </p>
        </div>

        <div className='paragraph'>
          <p>As John sees the ushering in of Christ’s Millennial kingdom he reports, “And the temple of God was opened in heaven, 
            and there was seen in his temple the ark of his testament: and there were lightnings, and voices, and thunderings, and an 
            earthquake, and great hail.”  
            <btn id="clickable21" className="footnote">21 </btn>
            <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>Revelation 11:15-19.</Tooltip>
            
            All this signifies the sounding of the trumpets of God’s angels, who will prepare the way for Christ’s coming to reign in glory, power, and majesty upon the cleansed and renewed earth.
          </p>
        </div>

        </div>

        <div className="chapterFooter">
          <Link to="/Chap11">Previous</Link>
          <Link to="/">Home</Link>
          <Link to="/Chap13">Next</Link>
      </div>
      
    </div>
  )
}

export default Chap12